module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ViewerImage"
  }, [_c('transition', {
    attrs: {
      "name": "ViewerImage-image-"
    }
  }, [(_vm.resolvedSrc) ? _c('img', {
    ref: "image",
    staticClass: "ViewerImage-image",
    attrs: {
      "src": _vm.resolvedSrc
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ViewerImage-progress-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgressBar),
      expression: "showProgressBar"
    }],
    staticClass: "ViewerImage-progress",
    style: (_vm.progressStyles)
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e2564fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewerImage.vue
// module id = 784
// module chunks = 1474